
export const APPROVE_ORDER= 'APPROVE_ORDER'
export const APPROVE_ORDER_SUCCESS= 'APPROVE_ORDER_SUCCESS'
export const APPROVE_ORDER_ERROR='APPROVE_ORDER_ERROR'


export const ApproveOrder= (data) => ({
    type: APPROVE_ORDER,
    payload: data
});